import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../../Constant";

const CreatePrivilege = () => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();

    const { invalidateApi } = useGlobalAPIQueryContext();

    const { useCreate } = useAPIQuery({
        key: "api/privileges",
        endpoint: "/api/privileges/",
    });

    const handleCreatePrivilege = (data) => {
        Swal.fire({
            title: "Privilege Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    invalidateApi({ key: "api/roles" });
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorPrivilege = (data) => {
        Swal.fire({
            title: "Error Adding Privilege",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreatePrivilege,
        onError: handleErrorPrivilege,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var privilege = {
            privilege_name: data.privilege_name,
            privilege_value: data.privilege_value,
            description: data.description,
            created_by: userID,
            updated_by: userID,
        };

        mutate({
            data: privilege,
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Create Privilege </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Privilege Display Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter privilege display name"
                                        id="text-forms-privilege_name"
                                        {...register("privilege_name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.privilege_name && (
                                        <span className="fs-8 text-danger">
                                            Privilege Display Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Privilege Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter privilege name"
                                        id="email-forms-privilege_value"
                                        {...register("privilege_value", {
                                            required: true,
                                        })}
                                    />
                                    {errors.privilege_value && (
                                        <span className="fs-8 text-danger">
                                            Privilege Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Description
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter description for privilege"
                                        id="textarea-forms-description"
                                        {...register("description", {
                                            required: true,
                                        })}
                                    />
                                    {errors.description && (
                                        <span className="fs-8 text-danger">
                                            Description is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-privilege-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-privilege"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreatePrivilege;
